"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryActionRecord = arbitraryActionRecord;
const tslib_1 = require("tslib");
const deep_diff_1 = require("deep-diff");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
function arbitraryActionRecord(constraints = {}) {
    return fast_check_1.default.record({
        actionRecordUid: fast_check_1.default.uuid(),
        actionName: fast_check_1.default.string(),
        actionUserUid: fast_check_1.default.uuid(),
        actionTimestamp: fast_check_1.default.integer({ min: 1667248086, max: 1767248086 }),
        actionChangeDiff: fast_check_1.default.constantFrom((0, deep_diff_1.diff)({ a: 1 }, { b: 2 })), // TODO, how awful
        actionUpdatesDocumentVersion: fast_check_1.default.boolean(),
        actionShouldBeAppliedUnconditionally: fast_check_1.default.boolean(),
        actionDocumentUid: constraints.documentUid ? fast_check_1.default.constant(constraints.documentUid) : fast_check_1.default.uuid(),
    });
}
//# sourceMappingURL=actionRecord.js.map